import React from 'react';
import CancelAlertPopup from 'src/pages/reportUsage/common/cancelAlertPopup';
import { useTranslation } from 'react-i18next';

const SurgeryOrderNonUsePopup = ({
    submitUsageOrder,
    returnToOrderClickHandler,
}) => {
    const { t } = useTranslation();
    return (
        <div>
            <CancelAlertPopup
                popupTitle={t('reportUsage.review.SurgeryOrderNonUsePopup.MarkNonUse')}
                alertMessage={
                    t('reportUsage.review.SurgeryOrderNonUsePopup.alertMsg')
                }
                btn1Label={t('reportUsage.review.SurgeryOrderNonUsePopup.returnToOrder')}
                btn2Label={t('reportUsage.review.SurgeryOrderNonUsePopup.submitUsage')}
                btn1ClickHandler={returnToOrderClickHandler}
                btn2ClickHandler={submitUsageOrder}
                btnCloseClickHandler={returnToOrderClickHandler}
                isSurgeryNonUsePopup
            />
        </div>
    );
};

export default SurgeryOrderNonUsePopup;
